// constants
import { TABS ,LAYOUT_MODES} from "../../constants/index";

export enum LayoutActionTypes {
  CHANGE_TAB = "@@layout/CHANGE_TAB",
  CHANGE_LAYOUT_MODE = "@@layout/CHANGE_LAYOUT_MODE",
  SET_GLOBAL_ERROR = "@@layout/SET_GLOBAL_ERROR",
  SET_PERM_NOTIFICATION = "@@layout/SET_PERM_NOTIFICATION",
  SET_IS_IN_FRAME = "@@layout/SET_IS_IN_FRAME",
  SET_FRAME_VALUE = "@@layout/SET_FRAME_VALUE",
  SET_VIEWPOST_SIZE = "@@layout/SET_VIEWPOST_SIZE",
}
export interface LayoutState {
  layoutMode:
    | LAYOUT_MODES.LIGHT
    | LAYOUT_MODES.DARK,
  activeTab:
    | TABS.BOOKMARK
    | TABS.CALLS
    | TABS.CHAT
    | TABS.CHAT_SUP
    | TABS.CONTACTS
    | TABS.SETTINGS
    | TABS.USERS
    | TABS.TEST
    | TABS.WORKPLACE
    ,

    chatConnectError?: string | null
    isGrantNotification: boolean
    ;
}
